// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".close-mobile-side-bar-btn[data-v-6c7af8d9]{position:fixed;bottom:50px;right:20px;font-size:23px;box-shadow:0 10px 15px -3px rgba(0,0,0,.1);background:#fff}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
